/**
 * Feature flags for temporarily hiding sections of the site.
 *
 * To restore the Home Loans vertical and Home Loan calculators, set
 * HIDE_HOME_LOANS back to `false`. Everything (routes, pages, links)
 * is preserved in the codebase — this flag only controls visibility.
 */
export const HIDE_HOME_LOANS = true;

/**
 * Wording helpers so copy that counts the loan verticals stays accurate
 * regardless of whether Home Loans is hidden. When HIDE_HOME_LOANS flips
 * back to `false`, all this copy automatically reverts to "four".
 */
export const VERTICAL_COUNT = HIDE_HOME_LOANS ? 3 : 4;
export const VERTICAL_COUNT_WORD = HIDE_HOME_LOANS ? "three" : "four";
export const VERTICAL_COUNT_WORD_CAP = HIDE_HOME_LOANS ? "Three" : "Four";

/** Comma-separated list of the active verticals, e.g. "car loans, personal loans and business loans". */
export const VERTICAL_LIST = HIDE_HOME_LOANS
  ? "car loans, personal loans and business loans"
  : "car loans, home loans, personal loans and business loans";

/** Short list of loan types, e.g. "car, personal or business". */
export const VERTICAL_SHORT_LIST = HIDE_HOME_LOANS
  ? "car, personal or business"
  : "car, home, personal or business";

/** Verticals where LoanGorilla offers a licensed broker service (excludes personal loans). */
export const BROKER_VERTICAL_LIST = HIDE_HOME_LOANS
  ? "car and business loans"
  : "car, home and business loans";
